/* Imán de tu recorrido (carrito): botón «Añadir imán» por pieza. */
(function () {
  if (window.__atImanCarrito) return;
  window.__atImanCarrito = true;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-at-iman]') : null;
    if (!b || b.disabled) return;
    var txt = b.textContent;
    b.disabled = true;
    b.textContent = '…';
    var props = {};
    try { props = JSON.parse(b.getAttribute('data-props') || '{}'); } catch (x) {}
    props['_Id pieza'] = b.getAttribute('data-token');
    props['_Imán de'] = b.getAttribute('data-modelo');
    fetch(b.getAttribute('data-add-url'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-variant')), quantity: Number(b.getAttribute('data-qty')) || 1, properties: props }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.status) { b.disabled = false; b.textContent = txt; return; }
        window.location.reload();
      })
      .catch(function () { b.disabled = false; b.textContent = txt; });
  });
})();